import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

import { timeout } from '../../lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'CMPageLazy',
        path: () => path.join(__dirname, './CMPage'),
        resolve: () => require.resolveWeak('./CMPage'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "CMPageLazy" */ './CMPage')]).then(
                (proms) => proms[0]
            ),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
